/*
 * @Author: your name
 * @Date: 2021-11-11 10:52:13
 * @LastEditTime: 2021-12-01 19:01:55
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /weapp-passportweb/src/components/pc/signup/store.ts
 */
import { observable, action, runInAction } from "mobx";
import { StepBaseProps } from '@weapp/ui';
import { signFormStore } from '../../../store/pc';
import { getLabel } from '@weapp/utils';

// import * as API from "../../../api/pc/list";

export class SignUpStore {
  // 当前step
  @observable stepsActive: number = 0;
  // steps数据
  @observable stepsData: Array<StepBaseProps> = [];
  // 注册账号类型
  @observable accountTypeIsPhone: boolean = true;


  init = () => {
    this.getSteps();
  }
  @action
  resetSignForm = (isPhone: boolean) => {
    signFormStore.resetForm();
    this.accountTypeIsPhone = isPhone;
  }
  /**
   * 步骤
   */
  @action
  getSteps = () => {
    this.stepsData = [
      { title: getLabel('93455', '填写个人信息') },
      { title: getLabel('93558', '验证账号') },
      { title: getLabel('225528', '加入或创建组织') }
    ]
  }
  /**
   * 变更账号类型
   * @param type 注册账号类型
   */
  @action
  changeAccountType = (isPhone: boolean) => {
    this.accountTypeIsPhone = isPhone;
  }

  /**
    * 更新steps组件状态
    */
  @action
  updateStepsActive = (v: number) => {
    this.stepsActive = v;
  }

}
const instance = new SignUpStore();

export default instance;
export type SignUpStoreType = Pick<SignUpStore, keyof SignUpStore>;
